import * as sessionSelectors from 'app_modules/session/selectors'
import actionTypes from 'app_modules/notifications/constants'
import api from 'api'

export const fetchDismissNotificationRequest = () => ({
  type: actionTypes.FETCH_DISMISS_NOTIFICATION_REQUEST,
})

export const fetchDismissNotificationSuccess = connectionId => ({
  type: actionTypes.FETCH_DISMISS_NOTIFICATION_SUCCESS,
  // Pass connectionId so the reducer can remove this specific notification from the list.
  payload: { connectionId },
})

export const fetchDismissNotificationFailure = error => ({
  type: actionTypes.FETCH_DISMISS_NOTIFICATION_FAILURE,
  payload: error,
})

/**
 * POST /account/:accountId/notifications/working_circle/dismiss
 * Dismisses a working circle notification by connection ID.
 * On success the notification is removed from the Redux store immediately.
 *
 * @param {number}   connectionId - The connection ID to dismiss.
 * @param {function} [onSuccess]  - Called on success.
 * @param {function} [onError]    - Called with the error on failure.
 */
export const fetchDismissNotification = (connectionId, onSuccess, onError) => {
  const thunk = (dispatch, getState) => {
    const accountId = sessionSelectors.accountId(getState())

    dispatch(fetchDismissNotificationRequest())

    const handleResponse = response => {
      dispatch(fetchDismissNotificationSuccess(connectionId))
      if (onSuccess) onSuccess(response)
    }

    const handleError = ({ error }) => {
      dispatch(fetchDismissNotificationFailure(error))
      if (onError) onError(error)
      else throw error
    }

    return api.notifications.dismissCircleNotification({ accountId, connectionId }, handleResponse, handleError)
  }

  thunk.type = actionTypes.FETCH_DISMISS_NOTIFICATION
  return thunk
}

export default fetchDismissNotification
